<div class="node-process-dialog">
  <wk-start-process
    [values]="formValues"
    (start)="startProcess()"
    (cancel)="closeDialog()"
  >
  </wk-start-process>
</div>
